declare const __GOOGLE_MAPS_API_KEY__: string
declare const __RECAPTCHA_KEY__: string

export const API_URL = '/api/v1/' as const
export const GOOGLE_MAPS_API_KEY = __GOOGLE_MAPS_API_KEY__
export const RECAPTCHA_KEY = __RECAPTCHA_KEY__
export const RECAPTCHA_FIELD_NAME = 'g-recaptcha-response'

export const POSTS_PER_PAGE = 20
export const COMMENTS_PER_PAGE = 30
export const FOLLOWED_USERS_PER_PAGE = 20
export const FOLLOWED_TAGS_PER_PAGE = 20
